import { getSharingTipRecipientInfoFromComposeViewState } from './getSharingTipRecipientInfoFromComposeViewState';
import { infoBarAddHandler, infoBarRemoveHandler } from './infoBarHandlers';
import { preloadLazyImports } from 'owa-attachment-block-on-send/lib/lazyIndex';
import { lazyRefreshSharingTipsAttachmentWell } from 'owa-attachment-well-data';
import { ComposeViewState } from 'owa-mail-compose-store';
import { SharingTipRecipientInfo } from 'owa-sharing-data';

let refreshSharingTipsAttachmentWell;

export async function refreshSharingTips(viewState: ComposeViewState) {
    if (!refreshSharingTipsAttachmentWell) {
        refreshSharingTipsAttachmentWell = await lazyRefreshSharingTipsAttachmentWell.import();
    }

    const recipientInfo: SharingTipRecipientInfo[] = await getSharingTipRecipientInfoFromComposeViewState(
        viewState
    );
    refreshSharingTipsAttachmentWell(
        viewState.attachmentWell,
        viewState.itemId,
        recipientInfo,
        viewState.infoBarIds.slice(),
        infoBarAddHandler(viewState),
        infoBarRemoveHandler(viewState)
    );

    preloadLazyImports();
}
